import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_ENVIRONMENT || 'development';

const isSentryEnabled = !!sentryDsn;

export const initSentry = () => {
  if (isSentryEnabled) {
    Sentry.init({
      dsn: sentryDsn,
      environment,
      normalizeDepth: 5,
      integrations: [
        new TracingIntegrations.BrowserTracing({
          idleTimeout: 60000,
        }),
      ],
      tracesSampleRate: 1.0,
    });
  }
};
